/**
 * Create a File object from an image source URL
 */
export const createFileFromImageSrc = async (
  src: string,
  filename: string,
): Promise<File> => {
  const response = await fetch(src);
  const blob = await response.blob();
  return new File([blob], filename, { type: blob.type });
};
